module.exports = __webpack_public_path__ + "img/play.2c7ae269.svg";